import type { IconProps } from '../types';

const Upload = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="m8.045 11.889 7.16-7.16c.439-.439 1.151-.439 1.59 0l7.16 7.16a1.125 1.125 0 1 1-1.591 1.59l-5.239-5.238v13.784h-2.25V8.241L9.636 13.48a1.125 1.125 0 1 1-1.59-1.591ZM28 28.025H4v-2.25h24v2.25Z" />
    <path d="M28 28.025v-2.25H4v2.25h24Z" />
    <path d="M5.125 28.025A1.125 1.125 0 0 1 4 26.9v-5.25a1.125 1.125 0 0 1 2.25 0v5.25c0 .621-.504 1.125-1.125 1.125Z" />
    <path d="M4 26.9a1.125 1.125 0 0 0 2.25 0v-5.25a1.125 1.125 0 0 0-2.25 0v5.25ZM26.875 28.025A1.125 1.125 0 0 1 25.75 26.9v-5.25a1.125 1.125 0 0 1 2.25 0v5.25c0 .621-.504 1.125-1.125 1.125Z" />
    <path d="M25.75 26.9v-5.25a1.125 1.125 0 0 1 2.25 0v5.25a1.125 1.125 0 0 1-2.25 0Z" />
  </svg>
);

export default Upload;
